import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    // Check localStorage for admin session
    const savedAdmin = localStorage.getItem('adminSession');
    if (savedAdmin) {
      const session = JSON.parse(savedAdmin);
      if (session.expiresAt > Date.now()) {
        setIsAdmin(true);
        setAdminUser(session.username);
      } else {
        localStorage.removeItem('adminSession');
      }
    }
  }, []);

  const login = (username, password) => {
    // Mock authentication - In production, this would be an API call
    if (username === 'admin' && password === 'markovic2024') {
      const session = {
        username,
        expiresAt: Date.now() + 24 * 60 * 60 * 1000, // 24 hours
      };
      localStorage.setItem('adminSession', JSON.stringify(session));
      setIsAdmin(true);
      setAdminUser(username);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('adminSession');
    setIsAdmin(false);
    setAdminUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAdmin, adminUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};